<h3>CIFRIS CLOUD</h3>
<p>
	Tra le attività della De Cifris troviamo l'iniziativa CifrisCloud che raccoglie
	i membri dell'iniziativa interessati alle molteplici interazioni tra la crittografia
	e il cloud computing. Senza limitarsi ai principali aspetti teorici in gioco nella
	Functional Encryption and Homomorphic Encryption, le tecniche per la Multiparty
	Computation e in genere per il Secret Sharing questo gruppo di interesse vuole fare
	il punto della situazione, trovando il fattore comune tra le scoperte dei ricercatori
	e le esigenze delle aziende.
</p>
<h5>Comitato organizzatore</h5>
<ul>
	<li>Marco Pedicini, Università Roma Tre.</li>
</ul>

<h4>SEMINARI RECENTI</h4>
<p>I seminari proposti verranno mostrati in questa sezione.</p>
<ul>
	<li>
		<b>31 Maggio 2022 - 17:00</b>
		<ul>
			<li>
				<b>Daniele Ballo</b> -- Eustema <br>
				<i>"Key management systems vs homorphic encryption"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/31.05.
								2022-Ballo.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisCloud/
								Ballo_31_Maggio.pdf">Slide</a> --
				<a href="https://mega.nz/file/rAlSgK4Y#jilX0d18Y8-
								r692I-tAFFn7UTB3F0qWcY7tqF87FIg8">Video</a>
			</li>
		</ul>
	</li>
</ul>

<h4>PROSSIMI SEMINARI</h4>
<ul>

</ul>


<h4>SEMINARI PASSATI</h4>
<ul>
	<li>
		<b>26 Maggio 2021 - 17:00</b>
		<ul>
			<li>
				<b>Marco Gaboardi</b> -- Boston University.<br>
				<i>"Differential privacy"</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/Gaboardi.pdf">Locandina</a> --
				<a href="https://mega.nz/file/Tw5QBABR#X-OVHfxpZbWo-EWmGy-C7kzX1hJGmCIYzbKoJZUVz5s">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>28 Aprile 2021 - 17:00</b>
		<ul>
			<li>
				<b>Marcello Paris</b> <br>
				<i>Attribute-based encryption and signatures</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/Paris.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisCloud/ParisSlide.pdf">Slide</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>24 Marzo 2021 - 17:00</b>
		<ul>
			<li>
				<b>Carla Mascia e Irene Villa</b> -- Università di Trento <br>
				<i>Functional Encryption, an overview</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/CarlaIrene.pdf">Locandina</a> --
				<a href="../../../assets/attivita/gruppi/cifrisCloud/CarlaIreneSlide.pdf">Slide</a> --
				<a href="https://mega.nz/file/Dc0BVCxC#lTpzQan1Hew20s-MOQ3DgmYWeiQMrqFcbCuiZ6MHwwg">Video</a>
				<br>
			</li>
		</ul>
	</li>
	<li>
		<b>9 Dicembre 2020</b>
		<ul>
			<li>
				<b>Francesco Leccese</b> -- NTT-Data & Università di Firenze <br>
				<i>Machine Learning vs Data Privacy</i><br>
			</li>
			<li>
				<b>Ilaria Chillotti</b> -- Zama, Paris <br>
				<i>Zama - End-to-end encryption for AI</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/CloudDeCifris-annuncio003.pdf">Locandina</a>
			</li>
		</ul>
	</li>
	<li>
		<b>11 Novembre 2020</b>
		<ul>
			<li>
				<b>Michela Iezzi</b> -- Banca d'Italia <br>
				<i>Homomorphic encryption for Financial Privacy: some use cases</i><br>
			</li>
			<li>
				<b>Emanuele Cesena</b> -- Pinterest, San Francisco <br>
				<i>Cryptography and growing a company in the cloud</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/CifrisCloud-annuncio002.pdf">Locandina</a>
			</li>
		</ul>
	</li>
	<li>
		<b>14 Ottobre 2020</b>
		<ul>
			<li>
				<b>Marco Pedicini</b> -- Università di Roma Tre <br>
				<i>Presentazione del nuovo ciclo di incontri di CifrisCloud</i><br>
				<a href="../../../assets/attivita/gruppi/cifrisCloud/CloudDeCifris-annuncio001.pdf">Locandina</a>
				<br>
			</li>
		</ul>
	</li>
</ul>